const locale = {
	// Main Page
	ROOMIE_AI_TITLE: 'RoomieAI е изкуствен интелект за управление на задачи',
    ROOMIE_AI_SUBTITLE: 'Интелигентно назначаване на стаи и управление на почистването с помощта на изкуствен интелект',
    
    // Tasks Assignment Page
    TASKS_PAGE_TITLE: 'Управление на задачите',
    TASKS_PAGE_DESC: 'Управлявайте задачите на вашият почистващ персонал с лекота и следете производителността на всеки един от тях',
	
	// Tabs
	CALENDAR_TAB: 'Календар',
	DASHBOARD_TAB: 'Табло',
	ANALYTICS_TAB: 'Анализи',
	SETTINGS_TAB: 'Настройки',

	// Dashboard
	ASSIGNMENT_DASHBOARD: 'Табло на задачите',
	REFRESH: 'Обнови',
	LAST_UPDATED: 'Последно обновено на:',
	TOTAL_ASSIGNMENTS: 'Общо възлагания',
	PENDING: 'Чакащи',
	ESTIMATED_TIME: 'Очаквано Време',
	MINUTES_TOTAL: ' минути общо',
	CLEANER_WORKLOADS: 'Текущи Задачи',
	RECENT_ACTIVITY: 'Последна Активност',
	WORKLOAD: 'Натовареност',
	TIME: 'Време',
	EFFICIENCY: 'Ефективност',
	NO_ASSIGNMENTS_TODAY: 'Няма възлагания за днес',
	NO_RECENT_ACTIVITY: 'Няма последна активност',
	COMPLETE_PROGRESS: '{{progress}}% завършено',
	OF: 'от',
	PERFORMANCE_SUMMARY_LAST_7_DAYS: 'Резюме на Производителността (Последните 7 Дни)',

	// Analytics
	PERFORMANCE_ANALYTICS: 'Анализи на Производителността',
	TIME_PERIOD: 'Времеви Период',
	LAST_7_DAYS: 'Последните 7 дни',
	LAST_30_DAYS: 'Последните 30 дни',
	LAST_90_DAYS: 'Последните 90 дни',
	TOTAL_RECORDS: 'Общо Записи',
	AVG_DURATION_MIN: 'Средна Продължителност (мин)',
	AVG_QUALITY_SCORE: 'Средна Оценка за Качество',
	ACTIVE_CLEANERS: 'Активни Чистачи',
	PERFORMANCE_BY_ROOM_TYPE: 'Производителност по Тип Стая',
	CLEANER_EFFICIENCY: 'Ефективност на Чистачите',
	COMPLETION_TRENDS: 'Тенденции на Завършване',
	TOP_PERFORMERS: 'Най-добри Изпълнители',
	RECORDS: 'Записи',
	NO_PERFORMANCE_DATA: 'Няма данни за производителност',
	EFFICIENCY_PERCENTAGE: 'Ефективност',
	QUALITY_VS_SPEED: 'Качество срещу Скорост',
	ROOM_TYPE_DISTRIBUTION: 'Разпределение по Тип Стая',
	ROOM_TYPE_PERFORMANCE_DETAILS: 'Детайли за Производителност по Тип Стая',
	CLEANER_PERFORMANCE_DETAILS: 'Детайли за Производителност на Чистачите',
	PERFORMANCE_TRENDS: 'Тенденции на Производителността',
	COUNT: 'Брой',
	ASSIGNMENTS: 'Възлагания',
	AVG_DURATION: 'Средна Продължителност',
	AVG_QUALITY: 'Средно Качество',

	// Settings
	ROOMIE_AI_SETTINGS: 'Настройки на RoomieAI',
	RESET: 'Нулиране',
	SAVE_CHANGES: 'Запази Промените',
	SETTINGS_SAVED_SUCCESS: 'Настройките са запазени успешно',
	
	// Auto Assignment Settings
	AUTO_ASSIGNMENT: 'Автоматично Назначаване',
	ENABLE_AUTO_DAILY_ASSIGNMENTS: 'Включи автоматично ежедневно назначаване',
	DAILY_GENERATION_TIME: 'Време за ежедневно генериране',
	ASSIGNMENT_ALGORITHM: 'Алгоритъм за назначаване',
	AUTO_SELECT_BEST: 'Автоматично избиране на най-добър алгоритъм',
	MIN_PERFORMANCE_RECORDS: 'Минимални записи за производителност за алгоритъм базиран на производителност',
	PERFORMANCE_WINDOW_DAYS: 'Прозорец за оценка на производителността (дни)',
	
	// Notification Settings
	NOTIFICATIONS: 'Известия',
	ASSIGNMENT_GENERATED_NOTIFICATION: 'Уведоми когато са генерирани назначения',
	ASSIGNMENT_COMPLETED_NOTIFICATION: 'Уведоми когато назначенията са завършени',
	PERFORMANCE_ALERTS: 'Изпращай предупреждения за производителност',
	DAILY_REPORTS: 'Изпращай ежедневни обобщаващи доклади',
	
	// Performance Settings
	PERFORMANCE_TRACKING: 'Проследяване на Производителността',
	TRACK_QUALITY_SCORES: 'Проследявай оценки за качество за завършени назначения',
	AUTO_RECORD_TIMES: 'Автоматично записвай времена за почистване',
	REQUIRE_NOTES: 'Изисквай бележки за завършване',
	QUALITY_THRESHOLD: 'Праг за оценка на качество за предупреждения',
	
	// Workload Settings
	WORKLOAD_MANAGEMENT: 'Управление на Натовареността',
	
	// Cleaning Time Settings
	CLEANING_TIMES: 'Стандартни Времена за Почистване',
	ALLOW_OVERLAPPING: 'Позволи припокриващи се назначения',
	ROOM_TYPE_TIMES: 'Времена по Тип Стая',
	MINUTES: 'минути',
	
	// Algorithm Settings
	ALGORITHM_SETTINGS: 'Настройки на Алгоритъма',
	PERFORMANCE_WEIGHT: 'Тежест на производителността (0-100%)',
	DISTANCE_WEIGHT: 'Тежест на разстояние/етаж (0-100%)',
	WORKLOAD_WEIGHT: 'Тежест на балансиране на натовареността (0-100%)',
	
	// Advanced Settings
	ADVANCED_SETTINGS: 'Разширени Настройки',
	ENABLE_AI_LEARNING: 'Включи AI обучение от исторически данни',
	DATA_RETENTION_DAYS: 'Период на съхранение на данни (дни)',
	BACKUP_FREQUENCY: 'Честота на резервно копие',
	DAILY: 'Ежедневно',
	WEEKLY: 'Седмично',
	MONTHLY: 'Месечно',
	
	// Status Messages
	CHANGES_SAVED: 'Промените са запазени успешно',
	CHANGES_DISCARDED: 'Промените са отхвърлени',
	INVALID_SETTINGS: 'Моля проверете настройките за невалидни стойности',
	DAILY_ASSIGNMENT_TIME: 'Време за Ежедневно Назначаване',
	DEFAULT_ALGORITHM: 'Стандартен Алгоритъм',
	AUTO_DETECT_BEST: 'Автоматично откриване на най-добър',
	MINIMUM_PERFORMANCE_RECORDS: 'Минимални Записи за Производителност',
	PERFORMANCE_WINDOW: 'Прозорец за Производителност',
	ASSIGNMENT_GENERATED: 'Назначение генерирано',
	ASSIGNMENT_COMPLETED: 'Назначение завършено',
	TRACK_QUALITY_SCORES_LABEL: 'Проследяване на оценки за качество',
	AUTO_RECORD_CLEANING_TIMES: 'Автоматично записване на времена за почистване',
	REQUIRE_COMPLETION_NOTES: 'Изискване на бележки за завършване',
	QUALITY_THRESHOLD_LABEL: 'Праг за Качество',
	DAYS: 'дни',
	ENABLE_AUTO_ASSIGNMENT: 'Разреши автоматични ежедневни назначения',
	MAX_ROOMS_PER_CLEANER: 'Максимални Стаи за Чистач',
	MAX_HOURS_PER_DAY: 'Максимални Часове на Ден',
	BALANCE_WORKLOAD: 'Балансирай работното натоварване между чистачите',
	CONSIDER_ROOM_TYPES: 'Вземи предвид типовете стаи при назначенията',
	CLEANING_CONFIGURATION: 'Конфигурация за Почистване',
	DEFAULT_CLEANING_TIMES: 'Стандартни Времена за Почистване (минути)',
	BUFFER_TIME: 'Време за пауза между задачи',
	ALLOW_OVERLAPPING_ASSIGNMENTS: 'Разреши припокриващи се назначения',
	SETTINGS_SAVED_SUCCESSFULLY: 'Настройките са запазени успешно!',
	ESTIMATED_TOTAL_TIME: 'Прогнозно Общо Време',
	FILTER: 'Филтър',
	PERFORMANCE_METRICS: 'Показатели за Производителност',

	// Header and Navigation
	ROOMS: 'Стаи',
	LIST: 'Списък', 
	TIMELINE: 'Времева линия',
	OVERVIEW: 'Преглед',
	FILTERS: 'Филтри',
	GENERATE_AI: 'Генериране с RoomieAI',
	AI: 'AI',
	SEARCH: 'Търсене',
	
	// Statistics and Summary
	TOTAL: 'Общо',
	DONE: 'Готови',
	RATE: 'Процент на завършване',
	ASSIGNED: 'Назначени',
	UNASSIGNED: 'Неназначени', 
	COMPLETED: 'Завършени',
	IN_PROGRESS: 'В процес на почистване',
	ASSIGNMENT_RATE: 'Процент на назначаване',
	COMPLETION_RATE: 'Процент на завършване',
	TOTAL_DURATION: 'Обща продължителност',
	CREATED_DATE: 'Дата на назначване',
	
	// Room Status
	ASSIGNED_STATUS: 'Назначена',
	ASSIGNED_NOT_COMPLETED_STATUS: 'Чакаща почистване',
	IN_PROGRESS_STATUS: 'В процес на почистване',
	COMPLETED_STATUS: 'Завършена',
	UNASSIGNED_STATUS: 'Неназначена',
	OVERDUE: 'Просрочена',
	CANCELLED: 'Отменена',
	SKIPPED: 'Прескочена',
	REASSIGNED: 'Преназначена',
	
	// Status (singular forms for tooltips)
	ASSIGNED_SINGULAR: 'Назначена',
	COMPLETED_SINGULAR: 'Завършена',
	IN_PROGRESS_SINGULAR: 'В процес',
	CANCELLED_SINGULAR: 'Отменена',
	SKIPPED_SINGULAR: 'Прескочена',
	
	// Actions
	ASSIGN_TO_CLEANER: 'Назначи към камериер',
	REASSIGN: 'Преназначаване',
	CANCEL_ASSIGNMENTS: 'Отмяна на назначения',
	CANCEL: 'Отказ',
	BULK_REASSIGN: 'Масово преназначаване',
	SELECT_ALL: 'Избери целия етаж',
	DESELECT_ALL: 'Откажи всички от етаж',
	SELECT_FLOOR: 'Избери етаж',
	DESELECT: 'Откажи',
	START_CLEANING: 'Започни почистване',
	REASSIGN_ALL: 'Преназначи всички',
	
	// Search and Filters
	SEARCH_PLACEHOLDER: 'Номер на стая, камериер, етаж...',
	SEARCH_PLACEHOLDER_DETAILED: 'Номер на стая, име на камериер, етаж...',
	SHOW_UNASSIGNED_ONLY: 'Покажи само неназначени',
	CLEAR_FILTERS: 'Изчисти филтри',
	ALL_STATUSES: 'Всички статуси',
	ALL_CLEANERS: 'Всички камериери',
	ALL_FLOORS: 'Всички етажи',
	ALL_ROOM_TYPES: 'Всички типове стаи',
	STATUS: 'Статус',
	LEGEND: 'Легенда',
	CLEANER: 'Камериер',
	FLOOR: 'Етаж',
	ROOM_TYPE: 'Тип стая',
	
	// Generate AI Dialog
	GENERATE_AI_ASSIGNMENTS: 'Генериране на AI назначения',
	SELECT_CLEANERS: 'Избери камериер',
	ALGORITHM_OPTIONAL: 'Алгоритъм (по избор)',
	AUTO_DETECT_ALGORITHM: 'Автоматично откриване на най-добър алгоритъм',
	PERFORMANCE_BASED: 'Базиран на производителност',
	FLOOR_BASED: 'Базиран на етаж',
	DATE_LABEL: 'Дата',
	GENERATE_ASSIGNMENTS: 'Генерирай назначения',
	
	// Room and Assignment Details
	ROOM: 'Стая',
	ROOM_NUMBER: 'Стая {{number}}',
	FLOOR_NUMBER: 'Етаж {{number}}',
	DURATION_MINUTES: '{{minutes}}мин',
	DURATION_HOURS: '{{hours}}ч {{minutes}}м',
	PRIORITY_LEVEL: 'Ниво на приоритет',
	ESTIMATED_DURATION: 'Очаквана продължителност',
	CLEANING_EMPLOYEE: 'Почистващ служител',
	TYPE: 'Тип',
	
	// Room Types
	STANDARD_ROOM: 'Стандартна стая',
	SINGLE_ROOM: 'Единична стая',
	DOUBLE_ROOM: 'Двойна стая',
	TWIN_ROOM: 'Стая с две единични легла',
	TRIPLE_ROOM: 'Тройна стая',
	QUEEN_ROOM: 'Стая с голямо легло',
	KING_ROOM: 'Стая с кралско легло',
	STUDIO_ROOM: 'Студио стая',
	SUITE: 'Апартамент',
	JUNIOR_SUITE: 'Малък апартамент',
	PRESIDENTIAL_SUITE: 'Президентски апартамент',
	
	// Priority Levels
	EXPRESS: 'Експресно',
	CHECKOUT: 'Освобождаване',
	NORMAL: 'Почистване/Заета',
	
	// Priority Explanations
	EXPRESS_PRIORITY_EXPLANATION: 'Експресно почистване - най-висок приоритет',
	CHECKOUT_PRIORITY_EXPLANATION: 'Почистване при освобождаване - гостът напуска',
	NORMAL_PRIORITY_EXPLANATION: 'Нормален приоритет за почистване - стандартно почистване на стая',
	
	// Room Conditions
	REGULAR_ROOM_CONDITION: 'Обичайно състояние на стаята',
	EXTRA_DIRTY_ROOM: 'Стаята изисква допълнително внимание при почистване',
	MAINTENANCE_NEEDED_ROOM: 'Стаята има проблеми с поддръжката, които трябва да се адресират',
	VIP_GUEST_ROOM: 'Стая за VIP гост - изисква се най-висок стандарт на обслужване',
	
	// Table Headers
	ACTIONS: 'Действия',
	PRIORITY: 'Приоритет',
	DURATION: 'Продължителност',
	
	// Dialogs and Messages
	REASSIGN_ROOM: 'Преназначи стая {{roomNumber}}',
	SELECT_NEW_CLEANER: 'Избери нов камериер',
	SELECT_CLEANER: 'Избери камериер', 
	REASON_OPTIONAL: 'Причина (по избор)',
	REASON_PLACEHOLDER: 'Въведи причина за преназначаване...',
	MANUAL_REASSIGNMENT: 'Ръчно преназначаване',
	
	// Bulk Operations
	BULK_REASSIGN_TITLE: 'Масово преназначаване на {{count}} {{type}}',
	ROOMS_SELECTED: '{{count}} стаи избрани',
	ASSIGNMENTS_SELECTED: '{{count}} назначения избрани', 
	ROOM_SINGULAR: 'стая',
	ROOMS_PLURAL: 'стаи',
	ASSIGNMENT_SINGULAR: 'назначение',
	ASSIGNMENTS_PLURAL: 'назначения',
	BULK_REASSIGN_WARNING: 'На път сте да преназначите {{count}} {{type}} към нов камериер.',
	BULK_REASSIGNMENT_REASON: 'Въведете причина за масово преназначаване...',
	BULK_REASSIGNMENT_FROM_ROOMS: 'Масово преназначаване от изглед на стаи',
	BULK_REASSIGNMENT: 'Масово преназначаване',
	
	// Assignment Dialog
	ASSIGN_ROOMS_TO_CLEANER_one: 'Назначи {{count}} стая към камериер',
	ASSIGN_ROOMS_TO_CLEANER_other: 'Назначи {{count}} стаи към камериер',
	ASSIGNING_ROOMS_FOR_DATE_one: 'Назначаване на {{count}} стая за {{date}}',
	ASSIGNING_ROOMS_FOR_DATE_other: 'Назначаване на {{count}} стаи за {{date}}',
	ASSIGNING: 'Назначаване...',
	ASSIGN_ROOMS_BUTTON_one: 'Назначи {{count}} стая',
	ASSIGN_ROOMS_BUTTON_other: 'Назначи {{count}} стаи',
	
	// Priority Change
	CHANGE_PRIORITY_FOR_ROOMS_one: 'Промяна на Приоритет за {{count}} Възлагане',
	CHANGE_PRIORITY_FOR_ROOMS_other: 'Промяна на Приоритет за {{count}} Възлагания',
	SELECT_NEW_PRIORITY_LEVEL: 'Изберете новото ниво на приоритет за избраните възлагания:',
	PRIORITY_CHANGE_EXPLANATION: 'Това незабавно ще актуализира нивото на приоритет за всички избрани възлагания.',
	UPDATE_PRIORITY: 'Актуализирай Приоритет',
	UPDATING: 'Актуализиране...',
	
	// Today's Summary
	TODAYS_SUMMARY: 'Дневна Обобщена Информация',
	CLEANER_PERFORMANCE: 'Производителност на камериерите',
	ASSIGNMENTS_COUNT: '{{count}} назначения',
	
	// Floor Statistics
	PROGRESS: 'В процес на почистване',
	
	// Loading and Status Messages
	LOADING: 'Зареждане...',
	NO_SESSIONS_FOUND: 'Няма намерени сесии за почистване',
	UNKNOWN_CLEANER: 'Неизвестен камериер',
	UNKNOWN_TYPE: 'Неизвестен тип',
	UNKNOWN_FLOOR: 'Неизвестен',
	
	// Date Navigation
	PREVIOUS_DAY: 'Предишен ден',
	NEXT_DAY: 'Следващ ден',
	
	// View Mode Messages
	NO_ASSIGNMENTS_MORE: '+{{count}} още назначения',
	
	// Success Messages
	ASSIGNMENTS_GENERATED: 'Назначенията са генерирани успешно',
	REASSIGNMENT_SUCCESSFUL: 'Преназначаването е завършено успешно',
	ASSIGNMENT_CANCELLED: 'Назначението е отменено успешно',
	
	// Error Messages
	SELECT_CLEANER_FIRST: 'Моля първо изберете камериер',
	SELECT_ROOMS_FIRST: 'Моля първо изберете стаи',
	NO_ROOMS_SELECTED: 'Няма избрани стаи',
	
	// Menu Actions
	START_MANUALLY: 'Започнато ръчно',
	CANCELLED_BY_ADMIN: 'Отменено от администратор',
	
	// Time Formatting
	HOURS_SHORT: 'ч',
	MINUTES_SHORT: 'м',
	
	// Duration Messages
	DURATION_IN_PROGRESS: 'Ще се покаже след завършване',
	DURATION_NOT_STARTED: 'Още не е започнато',
	
	// Express and Checkout priorities
	EXPRESS_ASSIGNED: 'Експресно назначено - тъмно червено',
	EXPRESS_IN_PROGRESS: 'Експресно в прогрес - ярко червено', 
	EXPRESS_COMPLETED: 'Експресно завършено - тъмно зелено',
	CHECKOUT_ASSIGNED: 'Освобождаване назначено - оранжево',
	CHECKOUT_IN_PROGRESS: 'Освобождаване в прогрес - ярко оранжево',
	CHECKOUT_COMPLETED: 'Освобождаване завършено - тъмно зелено',
	
	// Recent Activity Messages
	WAS_ASSIGNED_TO: 'беше назначена на',
	WAS_STARTED_BY: 'беше започната от',
	WAS_COMPLETED_BY: 'беше завършена от',
	
};

export default locale; 